// extracted by mini-css-extract-plugin
export default {"page":"Options_page__vKFR4","content":"Options_content__fO6I7","tabs-wrapper":"Options_tabs-wrapper__k1JrM","input-wrapper":"Options_input-wrapper__D+tC-"};